import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, forkJoin, map,  of, switchMap} from "rxjs";
import {environment} from "../../environments/environment";

import Base62Str from "base62str";
import {AttendeeQuery} from "./attendee.service";

import { getCurrentUser, fetchUserAttributes, fetchAuthSession} from 'aws-amplify/auth';

export type UserType = 'SUPERUSER' | 'TEACHER' | 'STUDENT' ;

export class SimpleUser {
  id!: string ;
  givenName: string
  familyName: string
  profileImage?: string
  bio?: string

  constructor(givenName:string, familyName: string) {
    this.givenName = givenName ;
    this.familyName = familyName ;
  }
}

export class User extends SimpleUser {
  username: string
  identityId: string
  email: string
  type?: UserType

  bioFlag?: Flag
  profileImageFlag?: Flag

  constructor(username: string, givenName:string, familyName: string, email:string, identityId:string) {

    super(givenName, familyName);
    this.username = username ;
    this.email = email;
    this.identityId = identityId ;
  }
}

export interface Flag {
  reason: string
  createdAt: Date
  createdBy: SimpleUser
}




@Injectable({
  providedIn: 'root'
})
export class UserService {

  base62 = Base62Str.createInstance();

  public user: BehaviorSubject<User|undefined> = new BehaviorSubject<User|undefined>(undefined);

  constructor(
    private http: HttpClient
  ) {

  }

  getUsername(email: string): string {
    return this.base62.encodeStr(email.toLowerCase());
  }

  getUser(): Observable<User> {

    if (this.user.value) {
      return of (this.user.value);
    }

    return this.http.get<User>(
      environment.apiHost + '/users/me'
    ).pipe(
      map((user: User) => {
        this.user.next(user);
        return user ;
      })
    );
  }

  getUserForcedReload(): Observable<User> {

    return this.http.get<User>(
      environment.apiHost + '/users/me'
    ).pipe(
      map((user: User) => {
        this.user.next(user);
        return user ;
      })
    );


  }

  clearUser() {
    this.user.next(undefined) ;
  }

  updateCurrentUser(): Observable<User> {

    return forkJoin([getCurrentUser(), fetchUserAttributes(), fetchAuthSession()])
      .pipe(
        switchMap((response:any) => {
          const user = response[0] ;
          const attributes = response[1];
          const session = response[2];

          let u = new User(
            user.username,
            attributes.given_name!,
            attributes.family_name!,
            attributes.email!,
            session.identityId,
          );
          return this.postUser(u, false)
        })
      ) ;
  }

  postUser(user:User, clearNullFields: boolean): Observable<User> {

    return this.http.post<User>(
      environment.apiHost + '/users',
      user,
      {params: {clearNullFields}}
    ).pipe(
      map((user: User) => {
        this.user.next(user);
        return user ;
      })
    );
  }

  flagBio(userId: string, reason:string): Observable<User> {

    return this.http.post<User>(
      environment.apiHost + `/users/${userId}/flags`,
      {field: 'BIO', reason: reason}
    )

  }

  flagProfileImage(userId: string, reason:string): Observable<User> {

    return this.http.post<User>(
      environment.apiHost + `/users/${userId}/flags`,
      {field: 'PROFILE_IMAGE', reason: reason}
    )

  }

  suggestUsers(query:AttendeeQuery, nameSubstring: string): Observable<SimpleUser[]> {

    let params = {
      q: JSON.stringify(query),
      nameSubstring
    }

    return this.http.get<SimpleUser[]>(
      environment.apiHost + `/attendee-users`,
      {params}
    )

  }



}
